import { HttpService } from '@application/http.service';
import { Injectable } from '@visiba/instantiation';
import { NotificationComplianceSettingsApiModel, UpdateNotificationComplianceSettingsApiModel } from './generated/clientv2/models';

@Injectable()
export class NotificationSettingsApiService {
	constructor(private readonly httpService: HttpService) {
		// Empty
	}

	public get() {
		return this.httpService.get<NotificationComplianceSettingsApiModel>(`/Client/v2/notificationsettings/Compliance`);
	}

	public update(data: UpdateNotificationComplianceSettingsApiModel) {
		return this.httpService.put<null>(`/Client/v2/notificationsettings/Compliance`, data);
	}
}
